import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FounderSection.css";
import founderImg from "../assets/founder.png";

const FounderSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="founder-section-home">
      <div className="founder-container-home">
        {/* Image */}
        <div className="founder-image-home" data-aos="fade-up">
          <img src={founderImg} alt="Mr. Lucas Thapa" />
        </div>

        {/* Content */}
        <div className="founder-content-home" data-aos="fade-up" data-aos-delay="200">
          <h2 className="founder-title-home">About the Founder</h2>
          <p className="founder-description-home">
            <strong>Mr. Lucas Thapa</strong>, Chairman of the 
            <strong> Development Education and Welfare Trust</strong>, founded this organization in <strong>2000</strong>.
            It is registered as a subordinate NGO (Trust) of West Bengal under registration number <strong>IV/93/2000</strong>.
          </p>
          <p className="founder-description-home">
            The main objective and philosophy focus on social, cultural, economic, and educational development 
            to bring <em>holistic transformation</em> and positive societal change through education and welfare initiatives.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
